<template>
  <div class="row">
    <div v-bind:class="propColunas">
      <div
        v-if="mensagem !== ''"
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <strong>{{ mensagem }}</strong>
      </div>
      <Dialog
        id="dialogEdit"
        titulo="Eventos"
        ref="dialog"
        :modal="propView == 'modal'"
      >
        <div class="text-left">
          <div class="row">
            <div
              class="col-sm-6"
              v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Site</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="$global.sites_filtro()"
                    v-model="item.site"
                    :erro="itemErros.site.status"
                  />
                  <div v-if="itemErros.site.status" class="invalid-feedback">
                    {{ itemErros.site.mensagem }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Servidor</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="servidoresHabilitados"
                    v-model="servidorSelecionado"
                    :erro="itemErros.servidor.status"
                  />
                  <div
                    v-if="itemErros.servidor.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.servidor.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-12 col-form-label">Nome</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.nome.status }"
                type="text"
                v-model="item.nome"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.nome.status" class="invalid-feedback">
                {{ itemErros.nome.mensagem }}
              </div>
            </div>
          </div>

          <div class="form-group row" v-if="retornaSite() !== 'Share'">
            <div class="col-md-12">
              <div class="row">
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Dia</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Mês</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Ano</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Hora</small></h6>
                </div>
                <div class="col">
                  <h6 style="margin-bottom: 0px"><small>Min</small></h6>
                </div>
              </div>
              <div class="row" style="margin-top: 10px">
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataDia"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataMes"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataAno"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataHora"
                  />
                </div>
                <div class="col">
                  <input
                    class="form-control"
                    type="text"
                    style="
                      border-top-left-radius: 0.25rem;
                      border-bottom-left-radius: 0.25rem;
                    "
                    @keyup="enterSalvar"
                    v-model="item.dataMinuto"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
          >
            <label class="col-sm-12 col-form-label">Link Fonte</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.linkFonte.status }"
                type="text"
                v-model="item.linkFonte"
                @keyup="enterSalvar"
              />
              <div v-if="itemErros.linkFonte.status" class="invalid-feedback">
                {{ itemErros.linkFonte.mensagem }}
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            v-if="retornaSite() == 'Share' && isAdmin"
          >
            <label class="col-sm-12 col-form-label">Redirect ID</label>
            <div class="col-sm-12">
              <input
                class="form-control"
                type="text"
                v-model="item.redirectId"
                @keyup="enterSalvar"
              />
            </div>
          </div>

          <div class="row" v-if="retornaSite() !== 'Share'">
            <div
              class="col-sm-6"
              v-bind:class="{
                'col-sm-6': retornaSite() !== '7live',
                'col-sm-12': retornaSite() == '7live',
              }"
            >
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Status</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: '1', nome: 'Previsto' },
                      { id: '2', nome: 'Invisivel' },
                      { id: '3', nome: 'Ao Vivo' },
                      { id: '4', nome: 'Encerrado' },
                    ]"
                    v-model="item.situacao"
                    :erro="itemErros.situacao.status"
                  />
                  <div
                    v-if="itemErros.situacao.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.situacao.mensagem }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div
                class="form-group row"
                v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
              >
                <label class="col-sm-12 col-form-label">Canais</label>
                <label class="col-sm-12 col-form-label" style="display: none"
                  >Max Usuários</label
                >
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: 1, nome: '1' },
                      { id: 2, nome: '2' },
                      { id: 3, nome: '3' },
                      { id: 4, nome: '4' },
                      { id: 5, nome: '5' },
                      { id: 6, nome: '6' },
                      { id: 7, nome: '7' },
                      { id: 8, nome: '8' },
                      { id: 9, nome: '9' },
                      { id: 10, nome: '10' },
                      { id: 11, nome: '11' },
                      { id: 12, nome: '12' },
                    ]"
                    v-model="item.canais"
                  />
                </div>
                <div
                  class="col-sm-12"
                  style="display: none"
                  v-if="retornaSite() !== 'Share'"
                >
                  <Combo
                    :itens="[
                      { id: 1, nome: '1' },
                      { id: 3, nome: '3' },
                      { id: 10, nome: '10' },
                      { id: 50, nome: '50' },
                      { id: 100, nome: '100' },
                      { id: 150, nome: '150' },
                      { id: 200, nome: '200' },
                      { id: 250, nome: '250' },
                    ]"
                    v-model="item.canaisUsuarios"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-group row"
            v-if="retornaSite() !== '7live' && retornaSite() !== 'Share'"
          >
            <div class="col-sm-12">
              <label class="col-sm-6 col-form-label" style="padding-left: 0px"
                >Html</label
              >
              <label
                class="col-sm-6 text-right"
                style="padding-right: 0px"
                v-if="false"
              >
                <button
                  type="button"
                  class="btn btn-dark btn-sm"
                  style="zoom: 0.8"
                  @click="htmlSofascore()"
                >
                  sofascore
                </button>
                <button
                  type="button"
                  class="btn btn-dark btn-sm"
                  style="margin-left: 5px; zoom: 0.8"
                  @click="htmlWillian()"
                >
                  willian
                </button>
              </label>
            </div>
            <div class="col-sm-12">
              <textarea
                class="form-control"
                v-bind:class="{ 'is-invalid': itemErros.sofaScore.status }"
                v-model="item.sofaScore"
                rows="4"
              />
              <div v-if="itemErros.sofaScore.status" class="invalid-feedback">
                {{ itemErros.sofaScore.mensagem }}
              </div>
            </div>
          </div>

          <div
            class="row"
            v-if="retornaSite() == '7live' || retornaSite() == 'Weddbets'"
          >
            <div class="col-sm-12">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Usuário</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="usuarios"
                    v-model="item.usuarioCriacao"
                    :erro="itemErros.usuarioCriacao.status"
                  />
                  <div
                    v-if="itemErros.usuarioCriacao.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.usuarioCriacao.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="row"
            v-if="retornaSite() !== 'Share' && retornaSite() !== '7live'"
          >
            <div class="col-sm-12">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Degustação</label>
                <div class="col-sm-12">
                  <Combo
                    :itens="[
                      { id: '0', nome: 'Não' },
                      { id: '1', nome: 'Sim' },
                    ]"
                    v-model="item.degustacao"
                    :erro="itemErros.degustacao.status"
                  />
                  <div
                    v-if="itemErros.degustacao.status"
                    class="invalid-feedback"
                  >
                    {{ itemErros.degustacao.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="retornaSite() == '7live'">
            <div class="col-sm-6">
              <div class="form-group row">
                <label class="col-sm-12 col-form-label">Valor</label>
                <div class="col-sm-12">
                  <input
                    class="form-control"
                    type="text"
                    v-model="item.valor"
                    @keyup="enterSalvar"
                  />
                  <div v-if="itemErros.valor.status" class="invalid-feedback">
                    {{ itemErros.valor.mensagem }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row" v-if="retornaSite() !== 'Share'">
            <div class="col-sm-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">SOFA</span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  @keyup="enterSalvar"
                  v-model="item.sofaScoreId"
                />
              </div>
            </div>
            <div class="col-sm-6">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">WILL</span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  @keyup="enterSalvar"
                  v-model="item.williamHillId"
                />
              </div>
            </div>
          </div>
        </div>

        <template v-slot:rodape>
          <button
            type="button"
            class="btn btn-secondary"
            v-if="view == 'modal'"
            data-dismiss="modal"
          >
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="salvarItem()">
            Salvar
          </button>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import Dialog from "../components/Dialog.vue";
import Combo from "../components/Combo.vue";
var _ = require("lodash");

export default {
  name: "EditEvento",
  components: { Dialog, Combo },
  props: {
    propView: { type: String, default: "modal" },
    propColunas: {
      type: Array,
      default: function () {
        return ["col-md-12"];
      },
    },
  },
  methods: {
    htmlSofascore() {
      var codigo = prompt("Preencha o código do jogo", "");

      if (codigo) {
        this.item.sofaScore =
          this.item.sofaScore +
          (this.item.sofaScore == "" ? "" : "\n") +
          '<iframe width="100%" height="84" frameborder="0" scrolling="no" src="/sofascore/' +
          codigo +
          '"></iframe>';
        //this.$set(this.item, "sofaScoreId", codigo);
      }
    },
    htmlWillian() {
      var codigo = prompt("Preencha o código do jogo", "");

      if (codigo) {
        this.item.sofaScore =
          this.item.sofaScore +
          (this.item.sofaScore == "" ? "" : "\n") +
          '<iframe width="100%" height="330" frameborder="0" scrolling="no" src="https://sports.staticcache.org/scoreboards/scoreboards-football/index.html?eventId=' +
          codigo +
          '&sport=football&locale=pt-pt"></iframe>';
        //this.$set(this.item, "williamHillId", codigo);
      }
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItem(id) {
      //* Limpa os campos
      this.novo();

      //* Carrega os dados
      var itemEdit = {};

      const response = await api.get("/evento/" + id);
      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        itemEdit = response.data.itens[0];
      }

      this.item._id = itemEdit._id;
      this.item.situacao = itemEdit.situacao.toString();
      this.item.site = itemEdit.site;
      this.item.nome = itemEdit.nome;
      this.item.servidor = itemEdit.servidor;
      this.item.servidorTipo = itemEdit.servidorTipo
        ? itemEdit.servidorTipo
        : "openvidu";
      this.item.canais = itemEdit.canais.toString();
      this.item.canaisUsuarios = itemEdit.canaisUsuarios.toString();
      this.item.linkFonte = itemEdit.linkFonte;
      this.item.dataDia = itemEdit.dataDia ? itemEdit.dataDia : "";
      this.item.dataMes = itemEdit.dataMes ? itemEdit.dataMes : "";
      this.item.dataAno = itemEdit.dataAno ? itemEdit.dataAno : "";
      this.item.dataHora = itemEdit.dataHora;
      this.item.dataMinuto = itemEdit.dataMinuto;
      this.item.sofaScore = itemEdit.sofaScore;
      this.item.sofaScoreId = itemEdit.sofaScoreId ? itemEdit.sofaScoreId : "";
      this.item.williamHillId = itemEdit.williamHillId
        ? itemEdit.williamHillId
        : "";
      this.item.usuarioCriacao = itemEdit.usuarioCriacao
        ? itemEdit.usuarioCriacao
        : null;

      //* Define o servidor selecionado
      this.servidorSelecionado =
        this.item.servidorTipo + "_" + this.item.servidor;

      if (itemEdit.degustacao) {
        this.item.degustacao = itemEdit.degustacao.toString();
      }

      if (itemEdit.redirectId) {
        this.item.redirectId = itemEdit.redirectId ? itemEdit.redirectId : "";
      }

      if (itemEdit.valor) {
        this.item.valor = itemEdit.valor ? itemEdit.valor : "0";
      }
    },
    async salvarItem() {
      this.mensagem = "";
      this.itemErros = util.errosLimpar(this.itemErros);

      var apiRequest;
      var body = _.cloneDeep(this.item);

      var arrServidorDados = this.servidorSelecionado.split("_");

      body.servidorTipo = arrServidorDados[0];
      body.servidor = arrServidorDados[1];

      if (
        body.situacao == "1" ||
        body.situacao == "2" ||
        body.situacao == "3" ||
        body.situacao == "4"
      ) {
        body.situacao = parseInt(body.situacao);
      }

      body.canais = parseInt(body.canais);
      body.canaisUsuarios = parseInt(body.canaisUsuarios);
      body.degustacao = parseInt(body.degustacao);

      if (this.item._id == "") {
        apiRequest = await api.post("/evento", body);
      } else {
        apiRequest = await api.put("/evento/" + this.item._id, body);
      }

      if (apiRequest.data.erro) {
        util.errosProcessar(this.itemErros, apiRequest.data.erros);
      } else {
        this.$refs.dialog.fechar();
        this.$emit("save-item");
      }
    },
    async novo() {
      var dataAtual = new Date();

      this.$set(this.item, "_id", "");
      this.$set(this.item, "site", "Todos");
      this.$set(this.item, "situacao", "2");
      this.$set(this.item, "nome", "");
      this.$set(this.item, "servidor", "https://sip1.weddbets.com");
      this.$set(this.item, "servidorTipo", "openvidu");
      this.$set(this.item, "canais", "1");
      this.$set(this.item, "canaisUsuarios", "500");
      this.$set(this.item, "linkFonte", "");
      this.$set(this.item, "dataDia", dataAtual.getDate().toString());
      this.$set(this.item, "dataMes", (dataAtual.getMonth() + 1).toString());
      this.$set(this.item, "dataAno", dataAtual.getFullYear().toString());
      this.$set(this.item, "dataHora", "");
      this.$set(this.item, "dataMinuto", "");
      this.$set(this.item, "sofaScore", "");
      this.$set(this.item, "sofaScoreId", "");
      this.$set(this.item, "williamHillId", "");
      this.$set(this.item, "degustacao", "0");
      this.$set(this.item, "redirectId", "");
      this.$set(this.item, "valor", "3");
      this.$set(
        this.item,
        "usuarioCriacao",
        this.usuarios.length > 0 ? this.usuarios[0].id : null
      );
      this.servidorSelecionado = "openvidu_https://sip1.weddbets.com";

      if (this.retornaSite() == "Share") {
        this.$set(this.item, "situacao", "3");
      }

      if (
        process.env.VUE_APP_SERVIDOR_PADRAO &&
        process.env.VUE_APP_SERVIDOR_PADRAO !== ""
      ) {
        var arrServidorPadrao = process.env.VUE_APP_SERVIDOR_PADRAO.split("_");

        if (arrServidorPadrao.length == 2) {
          this.servidorSelecionado = process.env.VUE_APP_SERVIDOR_PADRAO;
          this.$set(this.item, "servidor", arrServidorPadrao[1]);
          this.$set(this.item, "servidorTipo", arrServidorPadrao[0]);
        }
      }

      this.itemErros = util.errosLimpar(this.itemErros);
    },
    async enterSalvar(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        this.salvarItem();
      }
    },
  },
  async mounted() {
    this.view = this.propView;

    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";

    if (this.retornaSite() == "7live" || this.retornaSite() == "Weddbets") {
      const responseUsuario = await api.get("/usuario/apresentador");

      if (!responseUsuario.data.erro) {
        responseUsuario.data.itens.forEach(function (element) {
          element.id = element._id;
        });
        this.usuarios = responseUsuario.data.itens;
      }
    }
  },
  data: function () {
    return {
      item: {
        _id: "",
        site: "",
        situacao: "1",
        nome: "",
        servidor: "",
        servidorTipo: "",
        canais: "1",
        canaisUsuarios: "500",
        linkFonte: "",
        dataHora: "12",
        dataMinuto: "00",
        sofaScore: "",
        sofaScoreId: "",
        hilliamHillId: "",
        degustacao: "0",
        redirectId: "",
        valor: "3",
        usuarioCriacao: null,
      },
      servidorSelecionado: "",
      itemErros: {
        site: { status: false, mensagem: "" },
        situacao: { status: false, mensagem: "" },
        nome: { status: false, mensagem: "" },
        servidor: { status: false, mensagem: "" },
        linkFonte: { status: false, mensagem: "" },
        sofaScore: { status: false, mensagem: "" },
        degustacao: { status: false, mensagem: "" },
        usuarioCriacao: { status: false, mensagem: "" },
        valor: { status: false, mensagem: "" },
      },
      view: "",
      mensagem: "",
      usuarios: [],
      isAdmin: false,
    };
  },
  computed: {
    servidoresHabilitados: function () {
      return this.$global.servidores_sip_array().filter(function (item) {
        return item.router == false;
      });
    },
  },
};
</script>

<style></style>
